'use strict';

class Calculator {

    constructor() {
        this.type = window.rateType;

        this.form = null;
        this.formSlider = null;
        this.formSliderBubble = null;
        this.formSliderInput = null;
        this.formSliderInputDisplayed = null;
        this.formSliderMaxLabel = null;
        this.resultRegularWhole = null;
        this.resultRegularFraction = null;
        this.resultDiscountWhole = null;
        this.resultDiscountFraction = null;
        this.resultTotalWhole = null;
        this.resultTotalFraction = null;
        this.buttonFormSend = null;
        this.buttonFormApply = null;
        this.modalEmailResult = null;
        this.wrapperActions = null;
        this.wrapperResults = null;

        this.addOnsDropdown = null;
        this.addOnsWrapper  = null;

        this.sliderChangeCount = 0; // need to differentiate between initial slider move and manual move

        this.rates = {
            TermLife: {
                unitSize: 50000,
                // Monthly rates per $50,000 units of coverage
                regular: {
                    'male' : {
                        'nonsmoker' : [1.17, 1.29, 1.51, 1.97, 2.60, 3.71, 5.59, 10.17, 18.76, 28.57, 59.90],
                        'smoker'    : [2.05, 2.31, 3.43, 5.64, 7.86, 9.77, 21.14, 30.12, 39.70, 50.26, 105.54]
                    },
                    'female' : {
                        'nonsmoker' : [0.62, 0.73, 1.24, 1.46, 1.97, 2.41, 4.13, 6.96, 12.74, 13.53, 29.92],
                        'smoker'    : [1.06, 1.26, 2.51, 3.83, 5.15, 6.87, 14.34, 19.02, 29.46, 31.44, 69.42]
                    }
                },
                discount: null,
                applicationPDF: 'https://doctorsofbc.jotform.com/211574486351054',
                wsURL: 'https://doctorsofbc.azurewebsites.net/api/Calculate?code=zdwuIGqVf6460rq6uJNWkyusZSuIUkcNRYvxpG2DXC8azGx6MwNA2A==',
            },

            // !!! Disability calculation is DIFFERENT from TermLife and CriticalIllness. Age groups are DIFFERENT as well !!!
            Disability: {
                unitSize: 100,
                // Monthly Rates per $100 of benefit
                regular: {
                    'male' : {
                        'nonsmoker' : {
                            '28' : [1.3048, 2.0752, 2.5949, 3.0515, 3.8055, 4.5361, 5.2517, 3.1182],
                            '60' : [1.0477, 1.6662, 2.0816, 2.4476, 3.0524, 3.6382, 4.2126, 2.6583],
                            '90' : [0.7238, 1.0458, 1.7175, 2.0130, 2.7011, 3.1812, 3.6373, 2.5009],
                            '120' : [0.6570, 0.9516, 1.5610, 1.8300, 2.4549, 2.8902, 3.3062, 2.4160]
                        },
                        'smoker' : {
                            '28' : [1.6479, 2.6206, 3.1128, 3.6627, 4.5668, 5.4435, 6.3013, 3.7422],
                            '60' : [1.3213, 2.1036, 2.4980, 2.9390, 3.6637, 4.3672, 5.0552, 3.1907],
                            '90' : [0.9123, 1.3194, 2.0615, 2.4147, 3.2418, 3.8167, 4.3653, 3.0018],
                            '120' : [0.8290, 1.1996, 1.8730, 2.1960, 2.9472, 3.4694, 3.9674, 2.8997]
                        }
                    },
                    'female' : {
                        'nonsmoker' : {
                            '28' : [2.6123, 4.1578, 4.9346, 5.8066, 6.3666, 6.9692, 7.6868, 4.5647],
                            '60' : [2.0935, 3.3279, 3.9528, 4.6509, 5.0993, 5.5819, 6.1544, 3.8835],
                            '90' : [1.4448, 2.0899, 2.9399, 3.2611, 4.4551, 4.9388, 5.3147, 3.6545],
                            '120' : [1.3185, 1.9078, 2.6846, 2.9774, 4.0681, 4.5094, 4.8519, 3.5457]
                        },
                        'smoker' : {
                            '28' : [3.1366, 4.9849, 5.9246, 6.9686, 7.6384, 8.3642, 9.2239, 5.4769],
                            '60' : [2.5117, 3.9940, 4.7443, 5.5824, 6.1186, 6.6992, 7.3862, 4.6611],
                            '90' : [1.7321, 2.5071, 3.9144, 4.5869, 5.3463, 5.9263, 6.3777, 4.3863],
                            '120' : [1.5811, 2.2902, 3.5731, 4.1880, 4.8824, 5.4111, 5.8223, 4.2546]
                        }
                    }
                },
                discount: null,
                applicationPDF: '/assets/pdf/DoBC_INCOMEprotect_Disability_Insurance_Application-English.pdf',
                wsURL: 'https://dobcdisability2021.azurewebsites.net/api/Calculate?code=iycBBwBTmAG4OwaEo9EHVXSC8TbuhU00T1Z0ZpTBjF0YFVo6Ufk0QA==',
                incomeBenefit: [{"MinIncome":60000,"MaxIncome":62499,"Benefit":3500},{"MinIncome":62500,"MaxIncome":64999,"Benefit":3600},{"MinIncome":65000,"MaxIncome":68332,"Benefit":3800},{"MinIncome":68333,"MaxIncome":69999,"Benefit":3900},{"MinIncome":70000,"MaxIncome":72499,"Benefit":4000},{"MinIncome":72500,"MaxIncome":74999,"Benefit":4100},{"MinIncome":75000,"MaxIncome":77499,"Benefit":4200},{"MinIncome":77500,"MaxIncome":79999,"Benefit":4300},{"MinIncome":80000,"MaxIncome":82499,"Benefit":4400},{"MinIncome":82500,"MaxIncome":84999,"Benefit":4500},{"MinIncome":85000,"MaxIncome":87499,"Benefit":4600},{"MinIncome":87500,"MaxIncome":89999,"Benefit":4700},{"MinIncome":90000,"MaxIncome":96999,"Benefit":5000},{"MinIncome":97000,"MaxIncome":99999,"Benefit":5100},{"MinIncome":100000,"MaxIncome":104999,"Benefit":5200},{"MinIncome":105000,"MaxIncome":107499,"Benefit":5300},{"MinIncome":107500,"MaxIncome":109999,"Benefit":5400},{"MinIncome":110000,"MaxIncome":116999,"Benefit":5600},{"MinIncome":117000,"MaxIncome":119999,"Benefit":5700},{"MinIncome":120000,"MaxIncome":127499,"Benefit":6000},{"MinIncome":127500,"MaxIncome":129999,"Benefit":6100},{"MinIncome":130000,"MaxIncome":136999,"Benefit":6300},{"MinIncome":137000,"MaxIncome":139999,"Benefit":6500},{"MinIncome":140000,"MaxIncome":149999,"Benefit":6900},{"MinIncome":150000,"MaxIncome":159999,"Benefit":7300},{"MinIncome":160000,"MaxIncome":171249,"Benefit":7500},{"MinIncome":171250,"MaxIncome":180999,"Benefit":7600},{"MinIncome":181000,"MaxIncome":189999,"Benefit":8000},{"MinIncome":190000,"MaxIncome":201499,"Benefit":8300},{"MinIncome":201500,"MaxIncome":212499,"Benefit":8600},{"MinIncome":212500,"MaxIncome":219999,"Benefit":8900},{"MinIncome":220000,"MaxIncome":231249,"Benefit":9200},{"MinIncome":231250,"MaxIncome":239999,"Benefit":9500},{"MinIncome":240000,"MaxIncome":249999,"Benefit":9700},{"MinIncome":250000,"MaxIncome":261249,"Benefit":10000},{"MinIncome":261250,"MaxIncome":272499,"Benefit":10300},{"MinIncome":272500,"MaxIncome":279999,"Benefit":10600},{"MinIncome":280000,"MaxIncome":289999,"Benefit":10900},{"MinIncome":290000,"MaxIncome":299999,"Benefit":11100},{"MinIncome":300000,"MaxIncome":309999,"Benefit":11400},{"MinIncome":310000,"MaxIncome":321249,"Benefit":11600},{"MinIncome":321250,"MaxIncome":332499,"Benefit":11900},{"MinIncome":332500,"MaxIncome":339999,"Benefit":12100},{"MinIncome":340000,"MaxIncome":349999,"Benefit":12400},{"MinIncome":350000,"MaxIncome":359999,"Benefit":12600},{"MinIncome":360000,"MaxIncome":369999,"Benefit":12900},{"MinIncome":370000,"MaxIncome":379999,"Benefit":13100},{"MinIncome":380000,"MaxIncome":392499,"Benefit":13300},{"MinIncome":392500,"MaxIncome":399999,"Benefit":13500},{"MinIncome":400000,"MaxIncome":409999,"Benefit":13700},{"MinIncome":410000,"MaxIncome":419999,"Benefit":14000},{"MinIncome":420000,"MaxIncome":429999,"Benefit":14200},{"MinIncome":430000,"MaxIncome":439999,"Benefit":14500},{"MinIncome":440000,"MaxIncome":449999,"Benefit":14700},{"MinIncome":450000,"MaxIncome":459999,"Benefit":14900},{"MinIncome":460000,"MaxIncome":469999,"Benefit":15200},{"MinIncome":470000,"MaxIncome":479999,"Benefit":15400},{"MinIncome":480000,"MaxIncome":489999,"Benefit":15700},{"MinIncome":490000,"MaxIncome":499999,"Benefit":15900},{"MinIncome":500000,"MaxIncome":509999,"Benefit":16100},{"MinIncome":510000,"MaxIncome":519999,"Benefit":16400},{"MinIncome":520000,"MaxIncome":529999,"Benefit":16600},{"MinIncome":530000,"MaxIncome":539999,"Benefit":16900},{"MinIncome":540000,"MaxIncome":553299,"Benefit":17100},{"MinIncome":553300,"MaxIncome":559999,"Benefit":17400},{"MinIncome":560000,"MaxIncome":569999,"Benefit":17600},{"MinIncome":570000,"MaxIncome":579999,"Benefit":17800},{"MinIncome":580000,"MaxIncome":589999,"Benefit":18100},{"MinIncome":590000,"MaxIncome":599999,"Benefit":18300},{"MinIncome":600000,"MaxIncome":609999,"Benefit":18600},{"MinIncome":610000,"MaxIncome":619999,"Benefit":18900},{"MinIncome":620000,"MaxIncome":629999,"Benefit":19000},{"MinIncome":630000,"MaxIncome":639999,"Benefit":19300},{"MinIncome":640000,"MaxIncome":649999,"Benefit":19500},{"MinIncome":650000,"MaxIncome":659999,"Benefit":19700},{"MinIncome":660000,"MaxIncome":669999,"Benefit":20000},{"MinIncome":670000,"MaxIncome":679999,"Benefit":20200},{"MinIncome":680000,"MaxIncome":689999,"Benefit":20400},{"MinIncome":690000,"MaxIncome":699999,"Benefit":20700},{"MinIncome":700000,"MaxIncome":709999,"Benefit":20900},{"MinIncome":710000,"MaxIncome":719999,"Benefit":21100},{"MinIncome":720000,"MaxIncome":729999,"Benefit":21300},{"MinIncome":730000,"MaxIncome":739999,"Benefit":21600},{"MinIncome":740000,"MaxIncome":749999,"Benefit":21800},{"MinIncome":750000,"MaxIncome":759999,"Benefit":22000},{"MinIncome":760000,"MaxIncome":769999,"Benefit":22300},{"MinIncome":770000,"MaxIncome":779999,"Benefit":22500},{"MinIncome":780000,"MaxIncome":789999,"Benefit":22700},{"MinIncome":790000,"MaxIncome":799999,"Benefit":22900},{"MinIncome":800000,"MaxIncome":809999,"Benefit":23100},{"MinIncome":810000,"MaxIncome":819999,"Benefit":23300},{"MinIncome":820000,"MaxIncome":829999,"Benefit":23600},{"MinIncome":830000,"MaxIncome":839999,"Benefit":23700},{"MinIncome":840000,"MaxIncome":849999,"Benefit":24000},{"MinIncome":850000,"MaxIncome":859999,"Benefit":24100},{"MinIncome":860000,"MaxIncome":869999,"Benefit":24400},{"MinIncome":870000,"MaxIncome":879999,"Benefit":24600},{"MinIncome":880000,"MaxIncome":889999,"Benefit":24800},{"MinIncome":890000,"MaxIncome":949999,"Benefit":25000},{"MinIncome":950000,"MaxIncome":999999,"Benefit":26000},{"MinIncome":1000000,"MaxIncome":1099999,"Benefit":27000},{"MinIncome":1100000,"MaxIncome":1199999,"Benefit":28500},{"MinIncome":1200000,"MaxIncome":1299999,"Benefit":29800},{"MinIncome":1300000,"MaxIncome":1399999,"Benefit":30800},{"MinIncome":1400000,"MaxIncome":1499999,"Benefit":32000},{"MinIncome":1500000,"MaxIncome":1500001,"Benefit":33000}]
            },

            /*************** Critical Illness Rates ***************/
            Criticalillness: {
                unitSize: 10000,
                // Monthly Rates per $10,000 of benefit
                regular: {
                    'male' : {
                        'nonsmoker' : {
                            'basic'   : [0.9557, 1.3358, 1.6174, 2.3672, 4.0550, 6.5868, 10.4309, 17.1582],
                            'premium' : [1.0130, 1.4160, 1.7145, 2.5092, 4.2983, 6.9820, 11.0568, 18.1877]
                        },
                        'smoker' : {
                            'basic'   : [1.2401, 1.8751, 2.4922, 4.3919, 8.6610, 16.2677, 26.8946, 43.1794],
                            'premium' : [1.3145, 1.9876, 2.6417, 4.6554, 9.1806, 17.2437, 28.5082, 45.7702]
                        }
                    },
                    'female' : {
                        'nonsmoker' : {
                            'basic'   : [0.9093, 1.6955, 2.1318, 2.9022, 4.2130, 5.6254, 7.5775, 10.7367],
                            'premium' : [0.9639, 1.7972, 2.2597, 3.0764, 4.4658, 5.9629, 8.0322, 11.3809]
                        },
                        'smoker' : {
                            'basic'   : [1.0965, 2.3122, 3.4162, 5.4971, 8.7846, 12.2782, 16.0028, 20.5744],
                            'premium' : [1.1623, 2.4509, 3.6211, 5.8269, 9.3117, 13.0149, 16.9630, 21.8089]
                        }
                    }
                },
                discount: null,
                applicationPDF: 'https://doctorsofbc.jotform.com/211574486351054',
                wsURL: 'https://dobcCriticalIllness2021.azurewebsites.net/api/Calculate?code=ERl4jAWjFvRxZFbLl7og414w0G1BZFfFUvhWumXwVaQnDMstNkAjaA=='
            }
        }
    }

    init() {
        this.form = document.getElementById('formCalculator');
        this.formSlider = document.getElementById('calculatorCoverageSlider');
        this.formSliderBubble = document.getElementById('calculatorCoverageSliderBubble');
        this.formSliderInput = document.getElementById('calculatorCoverage');
        this.formSliderInputDisplayed = document.getElementById('calculatorCoverageDisplayed');
        this.formSliderMaxLabel = document.querySelector('.tps-calculator__form__slider__label--max');
        this.resultRegularWhole = document.getElementById('calculatorResultRegularWhole');
        this.resultRegularFraction = document.getElementById('calculatorResultRegularFraction');
        this.resultDiscountWhole = document.getElementById('calculatorResultDiscountWhole');
        this.resultDiscountFraction = document.getElementById('calculatorResultDiscountFraction');
        this.resultTotalWhole = document.getElementById('calculatorResultTotalWhole');
        this.resultTotalFraction = document.getElementById('calculatorResultTotalFraction');
        this.buttonFormSend = document.getElementById('buttonFormSend');
        this.buttonFormApply = document.getElementById('buttonFormApply');
        this.modalEmailResult = document.getElementById('modalEmailResult');
        this.wrapperActions = document.querySelector('.tps-calculator__form__actions');
        this.wrapperResults = document.querySelector('.tps-calculator__form__results');

        this.addOnsDropdown = document.getElementById('addOnsDropdown');
        this.addOnsWrapper  = document.getElementById('addOnsWrapper');

        /********** Critical Illness Page - Add-Ons Accordion **********/
        if (this.addOnsDropdown) {
            this.addOnsDropdown.addEventListener('click', () => {
                this.addOnsDropdown.classList.toggle('active');
                this.addOnsWrapper.classList.toggle('active');
            });
        }


        if (this.form) {
            this.onFormSubmit();
            this.onFormInputsChange();
            this.onFormSendClick();
            this.onFormApplyClick();
        }
    }

    onFormSubmit() {
        const self = this;
        self.form.addEventListener('submit', function(e) {
            e.preventDefault();
        });
    }

    onFormSendClick() {
        const self = this;
        self.buttonFormSend.addEventListener('click', function(e) {
            if (self.form.reportValidity()) {
                self.sendToService(true);
            }
        });
    }

    onFormApplyClick() {
        const self = this;

        self.buttonFormApply.addEventListener('click', function(e) {
            window.open(self.rates[self.type].applicationPDF);
        });
    }

    onFormInputsChange() {
        const self = this;

        const currencyFormatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        });

        const formSex = Array.prototype.slice.call(self.form.elements.sex);
        const formDoesSmoke = Array.prototype.slice.call(self.form.elements.doesSmoke);

        formSex.forEach(function(element) {
            element.addEventListener('change', function() {
                self.refreshRates();
            });
        });

        formDoesSmoke.forEach(function(element) {
            element.addEventListener('change', function() {
                self.refreshRates();
            });
        });

        self.form.elements.age.addEventListener('change', function() {
            self.refreshRates();
        });

        if (self.form.elements.annualEarnedIncome) {
            const message = document.querySelector('[data-message-for="' + self.form.elements.annualEarnedIncome.id + '"]');
            const min = parseInt(self.form.elements.annualEarnedIncome.dataset.min, 10);
            const max = parseInt(self.form.elements.annualEarnedIncome.dataset.max, 10);

            jQuery(self.form.elements.annualEarnedIncome).on('change blur', function() {
                let digitValue = self.form.elements.annualEarnedIncome.value.replace(/\D/g, '');

                if (digitValue === '') {
                    self.disableCoverageCalculation();
                    return;
                } else {
                    self.enableCoverageCalculation();
                }

                // automatically change if value is not within min and max
                if (digitValue < min) {
                    digitValue = min;
                    message.classList.remove('hide');
                } else if (digitValue > max) {
                    digitValue = max;
                    message.classList.remove('hide');
                } else {
                    message.classList.add('hide');
                }
                self.form.elements.annualEarnedIncome.value = currencyFormatter.format(digitValue).substring(1);

                // change maximum coverage amount based on Annual Earned Income (for Disability)
                const coverage = self.rates[self.type].incomeBenefit
                    .find(val => digitValue >= val.MinIncome && digitValue <= val.MaxIncome)
                    .Benefit;

                const slider = jQuery(self.formSlider);
                const start = slider.data('zfPlugin').options.start;

                slider.data('zfPlugin').options.end = coverage;

                // land in the middle, increases by 100
                let initialStartVal = ((coverage - start) / 2 ) + start;
                if (initialStartVal % 100 !== 0) {
                    initialStartVal = Math.floor(initialStartVal / 100) * 100;
                }
                slider.data('zfPlugin').options.initialStart = initialStartVal;

                slider.data('zfPlugin')._setInitAttr(0);
                slider.foundation('setHandles');
                self.formSliderMaxLabel.innerHTML = '<sup>$</sup>' + currencyFormatter.format(coverage).replace('$','');
            });

            // formatting the displayed coverage input value to include commas
            self.form.elements.annualEarnedIncome.addEventListener('keyup', function(e) {
                let digitValue = self.form.elements.annualEarnedIncome.value.replace(/\D/g, '');
                self.form.elements.annualEarnedIncome.value = currencyFormatter.format(digitValue).substring(1);
            });
        }

        if (self.form.elements.eliminationPeriod) {
            self.form.elements.eliminationPeriod.addEventListener('change', function() {
                self.refreshRates();
            });
        }


        /*************** Critical Illness Check Form Changes ***************/
        if(self.form.elements.waiverPremium && self.form.elements.childCriticalIllness) {
            const formWaiverPremium = Array.prototype.slice.call(self.form.elements.waiverPremium);
            const formChildCriticalIllness = Array.prototype.slice.call(self.form.elements.childCriticalIllness);

            formWaiverPremium.forEach(function(element) {
                element.addEventListener('change', function() {
                    self.refreshRates();
                });
            });

            formChildCriticalIllness.forEach(function(element) {
                element.addEventListener('change', function() {
                    self.refreshRates();
                });
            });
        }


        // formatting the displayed coverage input value to include commas
        self.formSliderInputDisplayed.addEventListener('keyup', function(e) {
            let digitValue = self.formSliderInputDisplayed.value.replace(/\D/g, '');
            self.formSliderInputDisplayed.value = currencyFormatter.format(digitValue).substring(1);
        });

        // if the "visual" input's value is changed, change the Foundation's slider's hidden input and call change
        jQuery(self.formSliderInputDisplayed).on('change blur', function(e) {
            const slider = jQuery(self.formSlider);

            let digitValue = self.formSliderInputDisplayed.value.replace(/\D/g, '');
            let adjustedValue = slider.data('zfPlugin')._adjustValue(null, digitValue);

            self.formSliderInput.value = adjustedValue;
            slider.foundation('setHandles');
        });

        // Every move
        jQuery(self.formSlider).on('moved.zf.slider', function() {
            if (!self.formSliderInput.value) self.formSliderInput.value = 200000;

            self.formSliderInputDisplayed.value = currencyFormatter.format(self.formSliderInput.value).substring(1);

            self.formSliderBubble.innerHTML = currencyFormatter.format(self.formSliderInput.value);
            self.refreshRates();
        });

        // Change after moving
        jQuery(self.formSlider).on('changed.zf.slider', function() {
            self.sliderChangeCount++;
            if (self.sliderChangeCount > 1) {
                self.sendToService(false);
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'coverage_changed',
                    'coverageValue': self.formSliderInput.value
                });
            }
        });
    }

    refreshRates() {
        const self = this;

        const sex = document.querySelector('input[name=sex]:checked').value;
        const doesSmoke = document.querySelector('input[name=doesSmoke]:checked').value === 'true';
        const age = self.form.elements.age.value;
        const coverage = self.formSliderInput.value;
        const eliminationPeriod = self.form.elements.eliminationPeriod ? self.form.elements.eliminationPeriod.value : null;

        /********** Critical Illness Get AddOns Info **********/
        const waiverPremium = self.form.elements.waiverPremium ? document.querySelector('input[name=waiverPremium]:checked').value : null;
        const childCriticalIllness = self.form.elements.childCriticalIllness ? document.querySelector('input[name=childCriticalIllness]:checked').value : null;

        const rates = self.calculateRates(sex, doesSmoke, age, coverage, eliminationPeriod, waiverPremium, childCriticalIllness);
        const regularPrice = rates.regularPrice.toFixed(2).split('.');

        if (rates.discount && rates.discountedPrice) {
            let discount = rates.discount.toFixed(2).split('.');
            let totalPrice = rates.discountedPrice.toFixed(2).split('.');

            self.resultRegularWhole.innerHTML = regularPrice[0];
            self.resultRegularFraction.innerHTML = '.' + regularPrice[1];
            self.resultDiscountWhole.innerHTML = discount[0];
            self.resultDiscountFraction.innerHTML = '.' + discount[1];
            self.resultTotalWhole.innerHTML = totalPrice[0];
            self.resultTotalFraction.innerHTML = '.' + totalPrice[1];
        } else {
            // total equals regular price
            self.resultTotalWhole.innerHTML = regularPrice[0];
            self.resultTotalFraction.innerHTML = '.' + regularPrice[1];
        }
    }

    calculateRates(sex, isSmoker, age, coverage, eliminationPeriod, waiverPremium, childCriticalIllness) {
        const self = this;

        let ageInterval = self.getAgeInterval(parseInt(age, 10));
        let smokerStatus = isSmoker ? 'smoker' : 'nonsmoker';

        // based on type
        let units = parseInt(coverage, 10) / self.rates[self.type].unitSize;
        let regularPrice = eliminationPeriod ? self.rates[self.type].regular[sex][smokerStatus][eliminationPeriod][ageInterval] * units : self.rates[self.type].regular[sex][smokerStatus][ageInterval] * units;
        let discount = self.rates[self.type].discount ? regularPrice * self.rates[self.type].discount : null;
        let discountedPrice = discount ? regularPrice - discount : null;


        /********** Critical Illness Calculate Rates **********/
        if (self.type === 'Criticalillness') {
            if (waiverPremium === 'true') {
                if(childCriticalIllness > 0) {
                    regularPrice =  ((coverage / self.rates[self.type].unitSize) * self.rates[self.type].regular[sex][smokerStatus]['premium'][ageInterval]) +
                                    ((childCriticalIllness/5000) * 2.64);
                } else {
                    regularPrice = ((coverage / self.rates[self.type].unitSize) * self.rates[self.type].regular[sex][smokerStatus]['premium'][ageInterval]);
                }
            } else {
                if(childCriticalIllness > 0) {
                    regularPrice =  ((coverage / self.rates[self.type].unitSize) * self.rates[self.type].regular[sex][smokerStatus]['basic'][ageInterval]) +
                                    ((childCriticalIllness/5000) * 2.64);
                } else {
                    regularPrice =  ((coverage / self.rates[self.type].unitSize) * self.rates[self.type].regular[sex][smokerStatus]['basic'][ageInterval]);
                }
            }
        }


        return {
            regularPrice: regularPrice,
            discountedPrice: discountedPrice,
            discount: discount
        };
    }

    getAgeInterval(age) {
        const self = this;

        if (self.type === 'TermLife') {
            if (age < 25) {
                return 0;
            } else if (age < 30) {
                return 1;
            } else if (age < 35) {
                return 2;
            } else if (age < 40) {
                return 3;
            } else if (age < 45) {
                return 4;
            } else if (age < 50) {
                return 5;
            } else if (age < 55) {
                return 6;
            } else if (age < 60) {
                return 7;
            } else if (age < 65) {
                return 8;
            } else if (age < 70) {
                return 9;
            } else if (age < 75) {
                return 10;
            }
        } else if (self.type === 'Criticalillness') {
            if (age < 30) {
                return 0;
            } else if (age < 35) {
                return 1;
            } else if (age < 40) {
                return 2;
            } else if (age < 45) {
                return 3;
            } else if (age < 50) {
                return 4;
            } else if (age < 55) {
                return 5;
            } else if (age < 60) {
                return 6;
            } else if (age < 65) {
                return 7;
            }
        } else {
            if (age < 35) {
                return 0;
            } else if (age < 40) {
                return 1;
            } else if (age < 45) {
                return 2;
            } else if (age < 50) {
                return 3;
            } else if (age < 55) {
                return 4;
            } else if (age < 60) {
                return 5;
            } else if (age < 65) {
                return 6;
            } else if (age < 70) {
                return 7;
            }
        }
    }

    sendToService(isEmail) {
        const self = this;

        const url = self.rates[self.type].wsURL;
        const age = parseInt(self.form.elements.age.value, 10);
        const sex = self.form.elements.sex.value;
        const doesSmoke = self.form.elements.doesSmoke.value === 'true';
        const coverage = parseInt(self.formSliderInput.value, 10);
        const email = isEmail ? self.form.elements.email.value : '';

        const data = {
            'age' : age,
            'sex' : sex,
            'is_smoker' : doesSmoke,
            'coverage_amount' : coverage,
            'email' : email
        };

        if (self.type === 'Disability') {
            if (self.form.elements.eliminationPeriod.value === '' && self.form.elements.annualEarnedIncome.value === '') {
                return;
            }
            data.period = parseInt(self.form.elements.eliminationPeriod.value, 10);
            data.income = parseInt(self.form.elements.annualEarnedIncome.value.replace(/\D/g, ''), 10);
        }

        if (self.type === 'Criticalillness') {
            data.premium = self.form.elements.waiverPremium.value;
            data.childCriticalIllness = self.form.elements.childCriticalIllness.value;
        }

        jQuery.ajax({
            url: url,
            type: 'POST',
            data: JSON.stringify(data),
            dataType: 'JSON',
            beforeSend: function() {
                self.buttonFormSend.setAttribute('disabled', 'disabled');
            }
        }).done(function(response) {
            if (isEmail) {
                jQuery(modalEmailResult).foundation('toggle');
                TPS.popups.hideAllPopups();
            }
        }).fail(function(response) {
            console.log(response);
            if (isEmail) alert('Error! Please try again.');
        }).always(function() {
            self.buttonFormSend.removeAttribute('disabled');
        });
    }

    enableCoverageCalculation() {
        const self = this;

        self.formSlider.classList.remove('disabled');
        self.formSliderMaxLabel.classList.remove('hide');
        self.formSliderBubble.classList.remove('hide');
        self.formSliderInputDisplayed.removeAttribute('disabled');
        self.wrapperResults.classList.remove('hide');
        self.wrapperActions.classList.remove('hide');
    }

    disableCoverageCalculation() {
        const self = this;

        self.formSlider.classList.add('disabled');
        self.formSliderMaxLabel.classList.add('hide');
        self.formSliderBubble.classList.add('hide');
        self.formSliderInputDisplayed.setAttribute('disabled', 'disabled');
        self.wrapperResults.classList.add('hide');
        self.wrapperActions.classList.add('hide');
    }
}
